import { render, staticRenderFns } from "./newTests.vue?vue&type=template&id=222cccd2&"
import script from "./newTests.vue?vue&type=script&lang=js&"
export * from "./newTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports